<template>
	<div id="exportDatePicker" class="datePickerContainer">
		<div class="selectDate">
			<div
				:class="{
					startDate: true,
					startDateSelected: focusingField === 'startDate'
				}"
			>
				<small>From</small>
				<p>{{ userSelectedStartDate }}</p>
			</div>
			<div
				:class="{
					endDate: true,
					endDateSelected: focusingField === 'endDate'
				}"
			>
				<small>To</small>
				<p>{{ userSelectedEndDate || "Tap a Date" }}</p>
			</div>
		</div>
		<div class="datepicker">
			<datepicker
				:value="selectedDateInPicker"
				:inline="true"
				@selected="userPickADate"
				:highlighted="highlightedDates"
			></datepicker>
		</div>
	</div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
export default {
	props: [
		"focusingField",
		"userSelectedStartDate",
		"userSelectedEndDate",
		"selectedDateInPicker",
		"userPickADate",
		"highlightedDates"
	],
	data() {
		return {};
	},
	components: {
		Datepicker
	}
};
</script>
